import * as v from "valibot";

// request：无业务参数，仅标准 Region（由 NodeAPI 方法注入）
export const RequestSchema = v.object({});
export type Request = v.InferOutput<typeof RequestSchema>;

// response（Content 为脚本文本；后端 swagger 标注 number 属文档错误，实际为 string）
const DataSchema = v.object({
  Content: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
